import React, { useEffect, useRef, useCallback, useLayoutEffect } from "react";

// components
import Loader from "../../Container/Loader";
import Modal from "../../Container/Modal";
import RightSideBar from "../../Container/RightSidebar";

// style
import HomeStyle from "./style";

//  images
import Sort from "../../Assets/sort.svg";
import DeleteIcon from "../../Assets/Delete.svg";
import Pen from "../../Assets/pen.svg";
import { useState } from "react";

// -- redux
import { connect } from "react-redux";
import { GetUser, GetTheme, UpdateUserStatus, ImportData, DeleteUser, GetUserServices, GetUserCsv } from "../../Redux/Actions/UserAction";

function Users(props) {
  const [response, setResponse] = useState(false);
  const [Open, SetOpen] = useState(false);
  const [Data, SetData] = useState("");
  const [page, setPage] = useState(1);
  const [sortType, setSortType] = useState("asc");
  const [sortBy, setSortBy] = useState("1");
  const [tableEntries, setTableEntries] = useState([]);
  const [hasMore, setHasMore] = useState("");
  const [OpenModal, setModal] = useState(false);
  const [Name, setName] = useState(false);
  const [UserId, setUserId] = useState(false);

  const observer = useRef();
  const lastItem = useCallback(
    (node) => {
      if (props.loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [props.loading, hasMore]
  );

  const handleEdit = (e, data) => {
    e.preventDefault();
    SetData(data);
    SetOpen(true);
  };

  useEffect(() => {
    setTimeout(function () {
      setResponse(true);
    }, 1000);
  }, []);

  const deleteUser = (e, type, id) => {
    e.preventDefault();
    setModal(type);
    setUserId(id);
  };

  useEffect(() => {
    if (props.search.length > 2) {
      const data = {
        page: page,
        sort_type: sortType,
        status: props.status.toString(),
        users: props.userData.toString(),
        sort_by: sortBy,
        search_key: props.search,
      };
      props.GetUser(data);
    } else {
      const data = {
        page: page,
        sort_type: sortType,
        status: props.status.toString(),
        users: props.userData.toString(),
        sort_by: sortBy,
        search_key: "",
      };
      props.GetUser(data);
    }
    SetOpen(false);
  }, [props.import_data, props.delete_data, props.edit_data, props.add_data, props.update_data, page, props.search, sortBy, sortType, props.userData, props.status]);

  useEffect(() => {
    if (props.data && props.data.data && props.data.data.data) {
      props.enabled(props.data.data.enabled);
      props.disabled(props.data.data.disabled);
      setTableEntries((prevData) => {
        return [...new Set([...prevData, ...props.data.data.data])];
      });
      setHasMore(props.data.data.data.length > 0);
    }
  }, [props.data]);

  const firstUpdate = useRef(true);

  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    props.ImportData(props.fileInfo);
  }, [props.fileInfo]);

  useEffect(() => {
    setTableEntries([]);
    setPage(1);
  }, [props.import_data, props.delete_data, props.edit_data, props.add_data, props.update_data, props.search, sortBy, sortType, props.userData, props.status]);

  useEffect(() => {
    props.import_data && response && props.UploadResp(props.import_data);
  }, [props.import_data]);

  useEffect(() => {
    props.GetTheme();
    props.GetUserServices();
    props.GetUserCsv();
  }, []);

  const handleSort = (e, type) => {
    e.preventDefault();
    switch (type) {
      case "email":
        setSortBy("2");
        sortType === "asc" ? setSortType("desc") : setSortType("asc");
        return;
      case "entry_type":
        setSortBy("3");
        sortType === "asc" ? setSortType("desc") : setSortType("asc");
        return;
      case "sec_level":
        setSortBy("4");
        sortType === "asc" ? setSortType("desc") : setSortType("asc");
        return;
      default:
        setSortBy("1");
        sortType === "asc" ? setSortType("desc") : setSortType("asc");
    }
  };

  const handleModal = (e, type, name, id) => {
    e.preventDefault();
    setModal(type);
    setName(name);
    setUserId(id);
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    let data;
    if (type === "enable_yes") {
      data = {
        id: UserId,
        user_status: 0,
      };
      props.UpdateUserStatus(data);
    } else {
      setModal(!OpenModal);
    }

    if (type === "disable_yes") {
      data = {
        id: UserId,
        user_status: 1,
      };
      props.UpdateUserStatus(data);
    } else {
      setModal(!OpenModal);
    }

    if (type === "delete_yes") {
      props.DeleteUser(UserId);
      setModal(false);
    } else if (type === "delete_no") {
      setModal(false);
    }
  };

  useEffect(() => {
    props.clear("clear");
    setTimeout(function () {
      props.clear("");
    }, 1000);
  }, []);

  const getEntryType = (type) => {
    switch (type) {
      case 0:
        return "Console";
      case 1:
        return "Import";
      default:
        return "Manual";
    }
  };

  const getSecurityType = (type) => {
    switch (type) {
      case 9:
        return "Admin";
      case 5:
        return "Sub-Admin";
      default:
        return "User";
    }
  };

  return (
    <>
      {props.loading && <Loader />}
      <div className="ml-4 mr-4">
        <div className="module-table-wrap table-responsive">
          <div className="table-wrap">
            <table className="table table-bordered m-0">
              <thead className="text-grey-6">
                <tr>
                  <th scope="col" className="dark-background">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Type</span>
                    </div>
                  </th>
                  <th onClick={(e) => handleSort(e, "entry_type")} scope="col" className="dark-background cursor-pointer">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Entry Type</span>
                      <img src={Sort} alt="sort" className="ml-2" />
                    </div>
                  </th>
                  <th onClick={(e) => handleSort(e, "sec_level")} scope="col" className="dark-background cursor-pointer">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Security</span>
                      <img src={Sort} alt="sort" className="ml-2" />
                    </div>
                  </th>
                  <th onClick={(e) => handleSort(e, "full_name")} scope="col" className="dark-background cursor-pointer">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Full Name</span>
                      <img src={Sort} alt="sort" className="ml-2" />
                    </div>
                  </th>
                  <th onClick={(e) => handleSort(e, "email")} scope="col" className="dark-background cursor-pointer">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Email Address</span>
                      <img src={Sort} alt="sort" className="ml-2" />
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Account</span>
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Balance</span>
                    </div>
                  </th>
                  {/* <th scope="col" className="dark-background">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Theme</span>
                    </div>
                  </th> */}
                  <th scope="col" className="dark-background">
                    <span className="f-16">Status</span>
                  </th>
                  <th scope="col" className="dark-background">
                    <span className="f-16">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody className="light-grey-background text-white">
                {tableEntries.length > 0
                  ? tableEntries.map((item, index) => {
                      const balance = item.balance ? item.balance.replace("$", "") : null;
                      const stringBalance = Number(balance);
                      return (
                        <tr key={index}>
                          {tableEntries.length === index + 1 ? (
                            <td ref={lastItem}>
                              <span className="f-16">
                                {item &&
                                  item.user_roles &&
                                  item.user_roles.length > 0 &&
                                  item.user_roles.map((role) => {
                                    return role.title;
                                  })}
                              </span>
                            </td>
                          ) : (
                            <td>
                              <span className="f-16">
                                {item &&
                                  item.user_roles &&
                                  item.user_roles.length > 0 &&
                                  item.user_roles.map((role) => {
                                    return role.title;
                                  })}
                              </span>
                            </td>
                          )}
                          <td style={{ width: "5%" }}>
                            <span className="f-16">
                              {getEntryType(item.entry_type)}
                              {/* {item.entry_type === 0 ? "Console" : "Import"} */}
                            </span>
                          </td>
                          <td>
                            <span className="f-16">{getSecurityType(item.sec_level)}</span>
                          </td>
                          <td>
                            <span className="f-16">{item.full_name}</span>
                          </td>
                          <td>
                            <span className="f-16">{item.email}</span>
                          </td>
                          <td>
                            <span className="f-16">{item.primary_account}</span>
                          </td>
                          <td style={{ width: "3%" }}>
                            <span className="f-16">{balance ? (balance.indexOf("Check") === -1 ? `$${balance}` : balance) : ""}</span>
                          </td>
                          {/* <td>
                            <span className="f-16">{item.title}</span>
                          </td> */}
                          <td className="text-center">
                            <label className="switch mb-0">
                              <input type="checkbox" checked={item.user_status === 1} readOnly onClick={(e) => handleModal(e, item.user_status === 1 ? "enable" : "disable", item.full_name, item.id)} />
                              <span className="slider round" />
                            </label>
                          </td>
                          <td>
                            <div className="d-flex">
                              <img
                                src={Pen}
                                alt="pen"
                                className="ml-2 mr-2 cursor-pointer"
                                onClick={(e) => {
                                  handleEdit(e, item);
                                }}
                              />
                              <img onClick={(e) => deleteUser(e, "delete", item.id)} src={DeleteIcon} alt="Delete" className="ml-2 mr-3 cursor-pointer" />
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  : props.table_loading === false && (
                      <tr>
                        <td colSpan="9" className="text-center border-0">
                          <p className="m-0 text-white">Nothing found</p>
                        </td>
                      </tr>
                    )}
              </tbody>
            </table>
            {props.table_loading && (
              <div className="text-center w-100">
                <p className="text-white mt-5 font-weight-bold">Loading...</p>
              </div>
            )}
            <HomeStyle />
          </div>
        </div>

        {props.theme_data && <RightSideBar Type="Edit" data={Data} theme={props.theme_data.data} sidebar={Open} close={() => SetOpen(false)} response={(e) => e} />}
        {props.user_services && <RightSideBar Type="Edit" data={Data} serviceList={props.user_services} sidebar={Open} close={() => SetOpen(false)} response={(e) => e} />}
        {OpenModal && <Modal Name={Name} Type={OpenModal} Close={(e, type) => CloseModal(e, type)} />}
      </div>
    </>
  );
}

const mapStateToProps = ({ GetUserReducer }) => {
  const { loading, table_loading, data, theme_data, delete_data, edit_data, add_data, update_data, import_data, user_services, csv_data } = GetUserReducer;
  return {
    loading,
    table_loading,
    data,
    theme_data,
    delete_data,
    edit_data,
    add_data,
    update_data,
    import_data,
    user_services,
    csv_data,
  };
};

const mapDispatchToProps = {
  GetUser,
  GetTheme,
  UpdateUserStatus,
  ImportData,
  DeleteUser,
  GetUserServices,
  GetUserCsv,
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
